import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import './styles';

export default class ProductBenefitsSection extends React.Component {
  render() {
    const { benefits } = this.props;

    const benefitGrid = _.map(benefits, (benefit, index) => (
      <div key={index} className="column">
        <div className="ui basic segment center-aligned">
          <i className={classnames(benefit.icon.size, benefit.icon.class)} />
          <h4 className="primary-text-bold m-t-half no-bottom">{benefit.text}</h4>
          <p className="secondary-text-regular">{benefit.description}</p>
        </div>
      </div>
    ));

    return (
      <div className="ProductBenefit">
        <div className="ui container">
          <div className="ui grid stackable p-b-1">
            <div className="equal width row">
              {benefitGrid}
            </div>
          </div>
        </div>
        <div className="ui fitted divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ProductBenefitsSection/index.jsx